module.exports = __webpack_public_path__ + "img/dancing.468bdd60.svg";